import _ from 'lodash';
import React, {PropTypes} from 'react';
import {
  Card,
  CardActions,
  CardText,
  Dialog,
  FlatButton,
  FontIcon,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TextField
} from 'material-ui';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/project';

const initialState = () => {
  return {
    openDialog: false,
    projectCode: '',
    projectName: '',
    linkUrl: '',
    projectCodeHasError: false,
    projectNameHasError: false,
    selectedProject: null
  };
};

class ProjectsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState();
    this.handleOpenDialog = this.handleOpenDialog.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleProjectCodeChange = this.handleProjectCodeChange.bind(this);
    this.handleProjectNameChange = this.handleProjectNameChange.bind(this);
    this.handleLinkUrlChange = this.handleLinkUrlChange.bind(this);
    this.handleSelectProject = this.handleSelectProject.bind(this);
    this.handleCreateProject = this.handleCreateProject.bind(this);
    this.handleEditProject = this.handleEditProject.bind(this);
    this.handleUpdateProject = this.handleUpdateProject.bind(this);
    this.handleDeleteProject = this.handleDeleteProject.bind(this);
    this.validateProject = this.validateProject.bind(this);
  }

  componentDidMount() {
    this.props.actions.fetchProjects();
  }

  handleOpenDialog() {
    this.setState({openDialog: true});
  }

  handleCloseDialog() {
    this.setState(initialState());
  }

  handleProjectCodeChange(event) {
    this.setState({projectCode: event.target.value});
  }

  handleProjectNameChange(event) {
    this.setState({projectName: event.target.value});
  }

  handleLinkUrlChange(event) {
    this.setState({linkUrl: event.target.value});
  }

  handleSelectProject(indexes) {
    const {projects} = this.props;
    this.setState({selectedProject: projects[indexes[0]]});
  }

  handleCreateProject() {
    const {
      projectCode,
      projectName,
      linkUrl
    } = this.state;

    const result = this.validateProject();

    if (result.projectCodeHasError === false && result.projectNameHasError === false) {
      const newProject = {
        code: projectCode,
        name: projectName,
        linkUrl: linkUrl
      };
      this.props.actions.createProject(newProject);
      this.handleCloseDialog();
    }
  }

  handleEditProject() {
    const {selectedProject} = this.state;

    this.setState({
      projectCode: selectedProject.code,
      projectName: selectedProject.name,
      linkUrl: selectedProject.linkUrl,
      openDialog: true
    });
  }

  handleUpdateProject() {
    const {
      projectCode,
      projectName,
      linkUrl,
      selectedProject
    } = this.state;

    const result = this.validateProject();

    if (result.projectCodeHasError === false && result.projectNameHasError === false) {
      this.props.actions.updateProject(selectedProject.key, {
        key: selectedProject.key,
        code: projectCode,
        name: projectName,
        linkUrl: linkUrl
      });
      this.handleCloseDialog();
    }
  }

  handleDeleteProject() {
    const {selectedProject} = this.state;
    if (confirm('Are you sure?')) {
      this.props.actions.deleteProject(selectedProject.key);
    }
  }

  handleSubmit() {
    const {selectedProject} = this.state;
    if (selectedProject === null) {
      this.handleCreateProject();
    } else {
      this.handleUpdateProject();
    }
  }

  validateProject() {
    const {projectCode, projectName} = this.state;
    let codeError = false;
    let nameError = false;

    if (projectCode === '') {
      codeError = true;
    }
    if (projectName === '') {
      nameError = true;
    }

    const result = {
      projectCodeHasError: codeError,
      projectNameHasError: nameError
    };
    this.setState(result);
    return result;
  }

  render() {
    const {
      openDialog,
      projectCode,
      projectName,
      linkUrl,
      projectCodeHasError,
      projectNameHasError,
      selectedProject
    } = this.state;

    const dialogActions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.handleCloseDialog}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onTouchTap={this.handleSubmit}
      />
    ];

    let cardActions = [
      <FlatButton icon={<FontIcon className="material-icons">add</FontIcon>} onTouchTap={this.handleOpenDialog} />
    ];
    if (_.isEmpty(selectedProject) === false) {
      cardActions.push(
        <FlatButton icon={<FontIcon className="material-icons">mode_edit</FontIcon>} onTouchTap={this.handleEditProject} />
      );
      cardActions.push(
        <FlatButton icon={<FontIcon className="material-icons">delete</FontIcon>} onTouchTap={this.handleDeleteProject} />
      );
    }

    const requiredText = 'You have to input this field';

    return (
      <div>
        <h1>Projects</h1>
        <Dialog
          title={selectedProject === null ? "New Project" : "Edit Project"}
          actions={dialogActions}
          modal={true}
          open={openDialog}
          onRequestClose={this.handleCloseDialog}
        >
          <form>
            <div>
              <TextField
                hintText="This field is required"
                floatingLabelText="Project Code"
                defaultValue={projectCode}
                errorText={projectCodeHasError ? requiredText : ''}
                onChange={this.handleProjectCodeChange}
              />
            </div>
            <div>
              <TextField
                hintText="This field is required"
                floatingLabelText="Project Name"
                defaultValue={projectName}
                errorText={projectNameHasError ? requiredText : ''}
                onChange={this.handleProjectNameChange}
              />
            </div>
            <div>
              <TextField
                hintText="This field is optional"
                floatingLabelText="Link URL"
                defaultValue={linkUrl}
                onChange={this.handleLinkUrlChange}
              />
            </div>
          </form>
        </Dialog>
        <Card>
          <CardActions children={cardActions} style={{textAlign: 'right'}} />
          <CardText>
            <Table onRowSelection={(rows) => this.handleSelectProject(rows)}>
              <TableHeader>
                <TableRow>
                  <TableHeaderColumn>Project Code</TableHeaderColumn>
                  <TableHeaderColumn>Project Name</TableHeaderColumn>
                  <TableHeaderColumn>Link URL</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody deselectOnClickaway={false}>
                {this.props.projects.map((p,i) => {
                  return <TableRow key={i} selected={_.isEmpty(selectedProject) === false  && selectedProject.key === p.key}>
                    <TableRowColumn>{p.code}</TableRowColumn>
                    <TableRowColumn>{p.name}</TableRowColumn>
                    <TableRowColumn>
                      {p.linkUrl ? <a href={p.linkUrl}>{p.linkUrl}</a> : ''}
                    </TableRowColumn>
                  </TableRow>;
                })}
              </TableBody>
            </Table>
          </CardText>
        </Card>
      </div>
    );
  }
}

ProjectsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  projects: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  return {
    projects: state.project.items
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectsPage);



/** WEBPACK FOOTER **
 ** ./src/components/ProjectsPage.js
 **/